import React, { useState } from "react";
import forgotPassStyles from "./ResetPassword.module.css";
import TextInput from "../../components/TextInput/TextInput";
import ButtonPrimary from "../../components/ButtonPrimary/ButtonPrimary";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Preloader from "../../components/Preloader/Preloader";
import { baseUrl } from "../../utilities/apiUrl";
import { useNavigate } from "react-router-dom";
import { titleUpdater } from "../../utilities/titleUpdater";
import $ from "jquery";

const ResetPassword = () => {
  titleUpdater("Reset your password");
  const customId = "id-static";
  const navigate = useNavigate();

  const notify = (msg) =>
    toast.error(msg, {
      toastId: customId,
    });

  const success = (msg) =>
    toast.success(msg, {
      toastId: customId,
      autoClose: 20000,
    });

  const [loading, setLoading] = useState(false);

  const handleResetPassword = (event) => {
    event.preventDefault();
    const email = event.target.email.value;
    const pass = event.target.pass.value;

    if (event.target.email.value === "") {
      notify("Email Address Required");
    } else if (pass === "") {
      notify("Password Required");
    } else {
      setLoading(true);
      $.ajax({
        type: "POST",
        url: `${baseUrl}/api/updatePassword.php`,
        data: { email: email, password: pass },
      })
        .then(function (res) {
          setLoading(false);
          let data = JSON.parse(res);
          if (data.error) {
            notify(data.error);
          } else {
            success("Your Password have been Updated");

            setTimeout(() => {
              navigate("/signin");
            }, 3000);
          }
        })
        .fail(function (res) {
          console.log(res);
        });
    }
  };

  return (
    <div className={forgotPassStyles.formBox}>
      <form
        className={forgotPassStyles.formContainer}
        onSubmit={handleResetPassword}
      >
        <h2>Reset Password?</h2>
        <p>Fill the form below to reset your password</p>

        <TextInput
          placeHolder="Enter Email Address"
          type="text"
          labelName="Email Address"
          name="email"
        />

        <TextInput
          placeHolder="New Password"
          type="password"
          labelName="New Password"
          name="pass"
        />

        <ButtonPrimary btnValue="Save Changes" />
      </form>

      <ToastContainer theme="light" />
      {loading ? <Preloader /> : null}
    </div>
  );
};

export default ResetPassword;
